import { gatherVideoClientDataSource, metricsManager as globalsMetricsManager } from "./Globals";
export const LOG_TO_NEWRELIC_TIMEOUTS_S = [10];
export var VideoPerformanceStages;
(function (VideoPerformanceStages) {
    VideoPerformanceStages["Desired"] = "desired";
    VideoPerformanceStages["PeerManagerSubscribe"] = "peerManagerSubscribe";
    VideoPerformanceStages["ConsumeStart"] = "consumeStart";
    VideoPerformanceStages["TrackReceived"] = "trackReceived";
    VideoPerformanceStages["RtpInspection"] = "rtpInspection";
    VideoPerformanceStages["RouterGetAddr"] = "routerGetAddr";
    VideoPerformanceStages["RouterSetAddr"] = "routerSetAddr";
    VideoPerformanceStages["ConsumeTry"] = "consumeTry";
    VideoPerformanceStages["ConsumeRequest"] = "consumeRequest";
    VideoPerformanceStages["ConsumeRequestEnd"] = "consumeRequestEnd";
    VideoPerformanceStages["ConsumeTryEnd"] = "consumeTryEnd";
    VideoPerformanceStages["ConsumePermissionPending"] = "consumePermissionPending";
    VideoPerformanceStages["ConsumePermissionPendingEnd"] = "consumePermissionPendingEnd";
})(VideoPerformanceStages || (VideoPerformanceStages = {}));
const videoPerformanceStatesArray = [
    VideoPerformanceStages.Desired,
    VideoPerformanceStages.PeerManagerSubscribe,
    VideoPerformanceStages.ConsumeStart,
    VideoPerformanceStages.TrackReceived,
];
class VideoPerformanceTracker {
    static _instance;
    _timeouts = {};
    static getInstance() {
        if (!this._instance) {
            this._instance = new VideoPerformanceTracker();
        }
        return this._instance;
    }
    mark(stage, id, tag) {
        const stageIndex = videoPerformanceStatesArray.findIndex((s) => stage === s);
        const previousStage = stageIndex !== 0 ? videoPerformanceStatesArray[stageIndex - 1] : null;
        if (previousStage) {
            LOG_TO_NEWRELIC_TIMEOUTS_S.map((timeout) => {
                this.clearTimeout(`${previousStage}-${id}-${tag}-${timeout}`);
            });
        }
        gatherVideoClientDataSource.performance().mark(`${stage}-${id}-${tag}`);
        if (stageIndex !== videoPerformanceStatesArray.length - 1) {
            LOG_TO_NEWRELIC_TIMEOUTS_S.map((timeout) => {
                this.addTimeout(`${stage}-${id}-${tag}-${timeout}`, () => {
                    globalsMetricsManager.addMetricReliably("stuckInVideoStage", {
                        stage: stage,
                        tag,
                        id,
                        timeout,
                    });
                }, timeout * 1000);
            });
        }
    }
    addTimeout(identifier, fn, timeout) {
        if (this._timeouts[identifier]) {
            this.clearTimeout(identifier);
        }
        this._timeouts[identifier] = window.setTimeout(fn, timeout);
    }
    clearTimeout(identifier) {
        const timeout = this._timeouts[identifier];
        if (timeout) {
            window.clearTimeout(timeout);
        }
        delete this._timeouts[identifier];
    }
    markStatic(stage, identifier, enableTimeout = false) {
        gatherVideoClientDataSource.performance().mark(`${stage}-${identifier}`);
        if (enableTimeout) {
            LOG_TO_NEWRELIC_TIMEOUTS_S.map((timeout) => {
                this._timeouts[`${stage}-${identifier}-${timeout}`] = window.setTimeout(() => {
                    globalsMetricsManager.addMetricReliably("stuckInVideoStage", {
                        stage: stage,
                        identifier: identifier,
                        timeout,
                    });
                }, timeout * 1000);
            });
        }
    }
    clearStatic(stage, identifier) {
        gatherVideoClientDataSource.performance().clearMarks(`${stage}-${identifier}`);
        LOG_TO_NEWRELIC_TIMEOUTS_S.map((timeout) => {
            if (this._timeouts[`${stage}-${identifier}-${timeout}`]) {
                clearTimeout(this._timeouts[`${stage}-${identifier}-${timeout}`]);
                delete this._timeouts[`${stage}-${identifier}-${timeout}`];
            }
        });
    }
    measureStatic(measureName, startStage, endStage, identifier) {
        if (gatherVideoClientDataSource.performance().getEntriesByName(`${startStage}-${identifier}`)
            .length === 0) {
            return;
        }
        try {
            this.markStatic(endStage, identifier);
            gatherVideoClientDataSource
                .performance()
                .measure(measureName, `${startStage}-${identifier}`, `${endStage}-${identifier}`);
            const performanceValue = gatherVideoClientDataSource
                .performance()
                .getEntriesByName(measureName)[0];
            this.clearStatic(startStage, identifier);
            this.clearStatic(endStage, identifier);
            gatherVideoClientDataSource.performance().clearMeasures(measureName);
            if (performanceValue)
                return performanceValue;
        }
        catch (_e) {
            console.warn(`Error while measuring ${measureName}`);
        }
        return null;
    }
    clearMarksAndMeasures = (srcId, kind) => {
        gatherVideoClientDataSource.performance().clearMeasures("subscribeTime");
        gatherVideoClientDataSource.performance().clearMeasures("subscribeToConsumeTime");
        gatherVideoClientDataSource.performance().clearMeasures("consumeToTrackTime");
        videoPerformanceStatesArray.map((stage) => {
            gatherVideoClientDataSource.performance().clearMarks(`${stage}-${srcId}-${kind}`);
        });
        videoPerformanceStatesArray.map((videoPerformanceState) => {
            LOG_TO_NEWRELIC_TIMEOUTS_S.map((timeout) => {
                const stageString = `${videoPerformanceState}-${srcId}-${kind}-${timeout}`;
                this.clearTimeout(stageString);
            });
        });
    };
}
export const videoPerformanceTracker = VideoPerformanceTracker.getInstance();
export const measureAvLoadtime = (srcId, kind, localUserId) => {
    videoPerformanceTracker.mark(VideoPerformanceStages.TrackReceived, srcId, kind);
    try {
        if (gatherVideoClientDataSource
            .performance()
            .getEntriesByName(`${VideoPerformanceStages.Desired}-${srcId}-${kind}`).length === 0) {
            videoPerformanceTracker.clearMarksAndMeasures(srcId, kind);
            return;
        }
        gatherVideoClientDataSource
            .performance()
            .measure("subscribeTime", `${VideoPerformanceStages.Desired}-${srcId}-${kind}`, `peerManagerSubscribe-${srcId}-${kind}`);
        gatherVideoClientDataSource
            .performance()
            .measure("subscribeToConsumeTime", `${VideoPerformanceStages.PeerManagerSubscribe}-${srcId}-${kind}`, `consumeStart-${srcId}-${kind}`);
        gatherVideoClientDataSource
            .performance()
            .measure("consumeToTrackTime", `${VideoPerformanceStages.ConsumeStart}-${srcId}-${kind}`, `trackReceived-${srcId}-${kind}`);
        const performanceValues = performance
            .getEntriesByType("measure")
            .filter(({ name }) => ["subscribeTime", "subscribeToConsumeTime", "consumeToTrackTime"].includes(name))
            .reduce((prev, current) => {
            const duration = Math.floor(current.duration);
            return { ...prev, totalMs: prev.totalMs + duration, [`${current.name}Ms`]: duration };
        }, { totalMs: 0, userId: localUserId, remoteUserId: srcId, kind });
        videoPerformanceTracker.clearMarksAndMeasures(srcId, kind);
        return performanceValues;
    }
    catch (e) {
        videoPerformanceTracker.clearMarksAndMeasures(srcId, kind);
        console.warn("Error while measuring video perf" + JSON.stringify(e));
    }
    return null;
};
//# sourceMappingURL=videoPerformance.js.map